import {NgModule} from "@angular/core";
import { CommonModule } from '@angular/common';

import { DashboardsRoutingModule } from './dashboards-routing.module';
import {Dashboard1Component} from "./dashboard1.component";
import {Dashboard2Component} from "./dashboard2.component";
import {Dashboard3Component} from "./dashboard3.component";
import {Dashboard4Component} from "./dashboard4.component";
import {Dashboard41Component} from "./dashboard41.component";
import {Dashboard5Component} from "./dashboard5.component";

// Chart.js Angular 2 Directive by Valor Software (npm)
import { ChartsModule } from 'ng2-charts';

import { FlotModule } from '../../components/charts/flotChart';
import { IboxtoolsModule } from '../../components/common/iboxtools/iboxtools.module';
import { PeityModule } from '../../components/charts/peity';
import { SparklineModule } from '../../components/charts/sparkline';
import { JVectorMapModule } from '../../components/map/jvectorMap';

import { SharedModule } from '../../components/shared/shared.module';
import { ComboToolsModule } from '../../components/common/comboTools/comboTools.module';
import { CheckboxModule } from 'primeng/checkbox';

@NgModule({
  declarations: [Dashboard1Component,Dashboard2Component,Dashboard3Component,Dashboard4Component,
    Dashboard41Component,Dashboard5Component],
  imports: [
    ChartsModule, 
    FlotModule,
    IboxtoolsModule,
    PeityModule,
    SparklineModule,
    JVectorMapModule,
    DashboardsRoutingModule,
    CommonModule,
    SharedModule,
    ComboToolsModule,
    CheckboxModule]
})

export class DashboardsModule {}
